// extracted by mini-css-extract-plugin
module.exports = {"root":"_1FlvwX","invert":"_1f-MB2"};